import * as React from "react";
import ButtonGroup from "widget/buttonGroup";

interface Data {
  Status: any;
}

let buttonGroup = props => {
  return [
    {
      label: "预订审核",
      enname:'verify',
      type: 13,
      style: {
        height:28
      }
    },
    {
      label: "修改",
      enname:'modify',
      type: 14,
      style: {
        height:28
      }
    },
    {
      label: "退订",
      type: 15,
      enname:'unsubscribe',
      style: {
        height:28
      }
    },
    {
      label: "合并订单",
      enname:'merge',
      type: 16,
      style: {
        height:28
      }
    },
    {
      label: "附加项目",
      enname:'additional',
      type: 17,
      style: {
        height:28
      }
    },
    {
      label: "取消退订",
      enname:'cancel_unsubscribe',
      type: 18,
      style: {
        height:28
      }
    },
    {
      label: "修改审核",
      enname:'modify_audit',
      type: 19,
      style: {
        height:28
      }
    },
    {
      label: "无需供应商",
      enname:'supplier_auto',
      type: 20,
      style: {
        height:28
      }
    }
  ];
};


// 获取按钮组中需要的按钮
const getButtonShowField = (nextProps:any) => {
  if(!nextProps.Status){
    return false;
  }
  const showButtonGroup = buttonGroup(nextProps).filter((item) => {
      return nextProps.Status.button.indexOf(item.enname) != -1;
  });
  return showButtonGroup;
};

class OrderDetailButtonStatus extends React.Component<Data> {
  state = {
    buttonGroup: [],
    isRefresh: false,
    status:''
  };

  constructor(props: Data) {
    super(props);
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
      return {
        isRefresh: false,
      };
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(Object.keys(nextProps.Status).length==0){
      return false;
    }

    if (prevState.status!= nextProps.Status.status) {
      if(nextProps.Status.button.length == 0){
         return false;
      }
      console.log('aaaaa',nextProps);
      const showButtonGroup = getButtonShowField(nextProps);
      this.setState({
        buttonGroup: showButtonGroup,
        isRefresh: true,
        status:nextProps.Status.status
      });
      return false;
    }
    return true;
  }

  render() {
    return (
      <React.Fragment>
        {<ButtonGroup buttonGroup={this.state.buttonGroup} />}
      </React.Fragment>
    );
  }
}

export default OrderDetailButtonStatus;

